import { isObject as t } from "../../utils/isObject.js";
const e = (r) => t(r) ? Object.prototype.hasOwnProperty.call(r, "focus") : !1;
export {
  e as componentHasFocus
};
